import React from "react"

const IntroSection = () => {
  return (
    <section className="bg-dark pt-6 pb-10 md:pt-12 md:pb-20 lg:pt-12">
      <div className="max-w-screen-md lg:max-w-screen-lg lg:mx-16 xl:mx-auto mx-auto">
        <div className="bg-secondary h-auto mx-2 md:mx-10 lg:mx-0 rounded-lg px-3 py-12 md:px-10 md:py-20">
          <div className="text-center">
            <h2 className="text-sm md:text-2xl lg:tracking-wide text-white pb-5 lg:pb-6 light-text">
              I help you with building the website which will be
            </h2>
            <div className="text-4xl md:text-6xl text-white  font-bold leading-tight">
              <span className="bg-clip-text text-transparent bg-gradient-to-br from-gray-800 via-white to-gray-800">
                Responsive. Fast. <br /> Customisable.
              </span>
            </div>
            <p className="text-white text-lg font-light extra-light-text tracking-normal pt-10 md:pt-16 lg:pt-20 md:px-5 md:text-2xl xl:px-16 xl:text-3xl">
              At the end, you'll experience a{" "}
              <span className=" text-yellow-500">conversion</span>
              -centered, <span className=" text-yellow-500">fast</span>{" "}
              performing, & <span className=" text-yellow-500">SEO</span>{" "}
              friendly website.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default IntroSection
